import { SearchInput as UDSSearchInput } from '@uds/input';
import { useField } from 'formik';
import { FormattedMessage } from 'react-intl';
import { InclusivelyHidden } from '@uds/inclusively-hidden';
import { ChangeEvent, createRef, ReactNode } from 'react';
import { IconName } from '@uds/glyphs';

import DomainSearchActionButton from './DomainSearchActionButton';
import { dstSubmitCTA } from './stylesheets/SearchInput.stylesheet';

export interface SearchInputProps {
  placeholder: string | undefined;
  disabled?: boolean;
  prefix?: ReactNode;
  tld?: string;
  glyph?: IconName;
  label?: string;
  ariaHidden: boolean;
}

const inputName = 'domainSearchTerm';

const SearchInput = ({
  disabled = false,
  prefix,
  placeholder,
  tld,
  glyph,
  label,
  ariaHidden,
}: Readonly<SearchInputProps>) => {
  const [{ value, onChange, onBlur, name }] = useField(inputName);
  const ariaProps = {
    'aria-hidden': ariaHidden,
  };
  const inputRef = createRef<HTMLInputElement>();
  return (
    <>
      <InclusivelyHidden>
        <FormattedMessage id="dst.v2.domain.search.input.label.accessible" />
      </InclusivelyHidden>
      <UDSSearchInput
        inputProps={{
          placeholder: placeholder,
          name,
          id: inputName,
          value,
          ref: inputRef,
          onChange: onChange,
          onKeyDown: (e: ChangeEvent<any>) => {
            e.target.setCustomValidity('');
            e.target.reportValidity();
          },
          onBlur,
          ...ariaProps,
        }}
        disabled={disabled}
        action={
          <DomainSearchActionButton
            className={dstSubmitCTA}
            disabled={disabled}
            label={label}
            glyph={glyph}
            inputRef={inputRef}
          />
        }
        prefix={prefix}
        suffix={tld}
      />
    </>
  );
};

export default SearchInput;
